module.exports = __webpack_public_path__ + "static/media/64e8-kavypmq5339321.388fc7a9.jpg";